import { useEffect, useState } from "react";
import Styles from "../editScreenStyles.module.css";
import inputUtilities from "../../../../utilities/forms/formInputUtilities";
import { yesNoUnsure } from "../../../../constants/options";
import { copyNestedObjArray, nameIsBlank, textToBoolean } from "../../../../utilities/dataUtilities";
import { useSelector } from "react-redux";

function WitnessesEdit({
  witnesses,
  setWitnesses,
  setIsVisible,
  isVisible,
  fields,
  utilities,
  validatePage,
  cancel
}) {
 const [emptyWits, setEmptyWits] = useState([]);
 const [originalWitnesses, setOriginalWitnesses] = useState([]);
 let witnessObj = useSelector((state) => state.anonAutoForm.witnessObj);
 
  const {
    createToggleInput
  } = utilities;

  const addWitness = (index) => {
    const newWitness = {
      firstName: {...witnessObj.firstName},
      lastName: {...witnessObj.lastName},
      witnessPhone: {...witnessObj.witnessPhone}
    };
    for (let fieldName in newWitness) {
      newWitness[fieldName] = {
        ...newWitness[fieldName],
        fieldName: `${newWitness[fieldName].fieldName}${witnesses.length + index}`,
      };
    }
   return newWitness;
  };

  const createWitness = (witness, index, witnessArray, setWitnessArray) => {
    const setWitness = (wit) => {
      const newWitnessInfo = [...witnessArray];
      newWitnessInfo[index] = wit;
      setWitnessArray(newWitnessInfo);
    };
    const createWitInput = inputUtilities(
      witness,
      setWitness,
      Styles
    ).createEditScreenInput;
    return (
      <li key={witness.firstName.fieldName} className={`${Styles.row} ${Styles.personContainer}`}>
        {createWitInput(
          witness.firstName,
          "100%",
          Styles.input,
          Styles.label
        )}
        {createWitInput(
          witness.lastName,
          "100%",
          Styles.input,
          Styles.label
        )}
        {createWitInput(
          witness.witnessPhone,
          "100%",
          Styles.input,
          Styles.label,
          { type: "tel"}
        )}
      </li>
    );
  };
  
  const updateClicked = () => {
    if (validatePage(7, true)) {
      const newWitnesses = [...witnesses];
      emptyWits
        .filter((wit) => !nameIsBlank(wit))
        .map((wit) => newWitnesses.push(wit));
      setWitnesses(newWitnesses);
      setEmptyWits([]);
      setIsVisible(false);
    }//add new witnesses if information was added to them
  };

  const cancelClicked = () => {
    setWitnesses([...originalWitnesses]);
    setEmptyWits([]);
    cancel();
  };

  useEffect(() => {
    setOriginalWitnesses(copyNestedObjArray(witnesses));
  }, [isVisible])

  useEffect(() => {
    if ((witnesses.length + emptyWits.length) < 4) {
      const numToAdd = 4 - witnesses.length - emptyWits.length;
      const wits = [...emptyWits];
      for (let i = 0; i < numToAdd; i++) {
        wits.push(addWitness(i));
      }
      setEmptyWits(wits);
    }
  }, [witnesses.length, emptyWits.length])

  useEffect(() => {
    if (!textToBoolean(fields.witnessesPresent.value)) {
      setWitnesses([]);
    }
  }, [fields.witnessesPresent.value])

  return (
    <div>
      <div className={Styles.title}>Witnesses</div>
        {createToggleInput(fields.witnessesPresent, "100%", yesNoUnsure, true)}
      <div className={Styles.column}>
        {
          textToBoolean(fields.witnessesPresent.value)
            && witnesses?.map((witness, index) => createWitness(witness, index, witnesses, setWitnesses))
        }
        {textToBoolean(fields.witnessesPresent.value)
          && emptyWits?.map((witness, index) => createWitness(witness, index, emptyWits, setEmptyWits))}
        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default WitnessesEdit;
